import { render } from "./homeRead.vue?vue&type=template&id=dc71cd3a"
import script from "./homeRead.vue?vue&type=script&lang=js"
export * from "./homeRead.vue?vue&type=script&lang=js"

import "./homeRead.vue?vue&type=style&index=0&id=dc71cd3a&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__